import toast from 'react-hot-toast'
import { Button } from 'components/common'
import { ICellRendererParams } from '@ag-grid-community/core'
import { updateFtpConfigurations } from 'utils/api/ftpConfigurationApi'

const handleSave = async (params: ICellRendererParams, isEditor: boolean) => {
  if (!isEditor) return

  const ftpToast = toast.loading('Updating Configurations...')

  const rowNode = params.api.getRowNode(params.data._id)

  try {
    const aggregators = rowNode?.data.aggregators.map((agg: any) => agg._id)

    await updateFtpConfigurations({
      ftpConfigId: rowNode?.data._id,
      data: { aggregators },
    })

    toast.success('Configurations Updated successfully!', { id: ftpToast })
  } catch (error) {
    toast.error('Failed to update configurations', { id: ftpToast })
  }
}

type ActionCellRendererProps = {
  params: ICellRendererParams
  isEditor: boolean
}

const ActionCellRenderer = ({ params, isEditor }: ActionCellRendererProps) => {
  return (
    <div>
      <Button
        size="small"
        className="w-28"
        buttonText="Save"
        type="button"
        onClick={() => handleSave(params, isEditor)}
      />
    </div>
  )
}

export default ActionCellRenderer
